import { Quote } from "lucide-react";

export default function MarketingBanner() {
  return (
    <section
      data-testid="marketing-banner"
      className="py-20 md:py-28 bg-forest-700 relative overflow-hidden"
    >
      <div className="absolute top-0 left-0 w-64 h-64 bg-forest-600/30 rounded-full -translate-x-1/2 -translate-y-1/2"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-forest-600/20 rounded-full translate-x-1/3 translate-y-1/3"></div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center">
          <Quote className="w-12 h-12 text-forest-300/50 mx-auto mb-6" />
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-white font-bold mb-6 leading-tight">
            Where Quality Meets
            <span className="text-forest-200"> Dedication</span>
          </h2>
          <p className="text-xl sm:text-2xl text-forest-100/90 mb-8 max-w-3xl mx-auto leading-relaxed">
            At Georgia Outdoor Worx, we don't just maintain landscapes — we create outdoor spaces
            that inspire. With attention to detail and a commitment to excellence,
            we transform your property into something extraordinary.
          </p>
          <div className="flex flex-wrap justify-center gap-8 mt-12">
            <div className="text-center">
              <div className="text-4xl font-bold text-forest-200">100%</div>
              <div className="text-forest-300 text-sm mt-1">Customer Satisfaction</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-forest-200">24/7</div>
              <div className="text-forest-300 text-sm mt-1">Available Support</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-forest-200">Free</div>
              <div className="text-forest-300 text-sm mt-1">Estimates</div>
            </div>
          </div>
          <p className="text-forest-200 font-serif text-2xl mt-12 italic">
            "Your Best Choice for Outdoor Excellence"
          </p>
        </div>
      </div>
    </section>
  );
}
